import { AppliedPromo, ProductCartItem } from '../../types/common';
import { YM_ECOM_ID } from './config';

export function pushEcommerceCheckout(cartProducts: ProductCartItem[], payableTotal: number, shippingCost: number | null, appliedPromo: AppliedPromo | null) {
    if (process.env.NODE_ENV !== 'production') return;
    if (!YM_ECOM_ID) return;
    if (typeof window === 'undefined') return;
    if (!Array.isArray(cartProducts) || cartProducts.length === 0) return;
    const products = cartProducts
        .map((item) => {
            const unitPriceSource = (item as any).specialDiscountedPrice ?? (item as any).discountedPrice ?? (item as any).price;
            const unitPrice = typeof unitPriceSource === 'number' && Number.isFinite(unitPriceSource) ? unitPriceSource : undefined;
            const qty = Number.isFinite(Number(item.quantity)) && Number(item.quantity) > 0 ? Number(item.quantity) : 1;
            const id = String(item.productId || '').trim();
            const name = String(item.name || '').trim();
            if (!id || !name || !unitPrice || qty <= 0) return null;
            return {
                id,
                name,
                price: Number(unitPrice),
                quantity: qty,
            };
        })
        .filter(Boolean) as Array<{ id: string; name: string; price: number; quantity: number }>;
    if (!products.length) return;
    const shipping = typeof shippingCost === 'number' && Number.isFinite(shippingCost) && shippingCost > 0 ? shippingCost : 0;
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
        ecommerce: {
            currencyCode: 'RUB',
            checkout: {
                actionField: {
                    step: 1,
                    ...(shipping ? { shipping } : {}),
                    ...(appliedPromo?.code ? { coupon: appliedPromo.code } : {}),
                },
                products,
            },
        },
    });
}
